<template>
	<div class="report-wealth-energy">
		<div class="report-cloud cloud2"></div>
		<div class="report-title title2"></div>
		<div class="report-content">
			<!-- 未解锁 -->
			<pay-button 
				v-if="reportSPayData && reportSPayData.needpay == 1"
				v-bind:bText="'一键解锁财运报告'"
				v-bind:bPid="userPageData.id"
				v-bind:bData="reportSPayData"
				v-bind:btnFunc="clickPay">
			</pay-button>
			<!-- 数据表 -->
			<div v-if="reportSPayData && reportSPayData.needpay == 0" class="report-table">
				<report-data-area 
					:canvasId="'wealthCanvas'"
					:xDataArr="reportSMCategories"
					:yDataArr="reportSMSeries">
				</report-data-area>
			</div>
			<div v-if="reportSPayData && reportSPayData.needpay == 1" class="text-c pos-r">
				<div class="table-blur"></div>
				<div class="report-lock" @click="clickPay"></div>
			</div>
			<!-- 按月财运趋势 -->
			<div class="report-title-word"><span class="text">按月财运趋势</span></div>
			<!-- 四季12个月 -->
			<div v-if="reportSPayData && reportSPayData.needpay == 1" class="report-month-content-2 c-green">
				<div class="text-blur text3"></div>
				<div class="report-lock" @click="clickPay"></div>
				<div class="report-season spring"></div>
				<div class="report-gold gold-0"></div>
			</div>
			<div v-if="reportSPayData && reportSPayData.needpay == 0">
				<div class="report-month-content-2" :class="'c-'+colorArr[mIndex]+' c-'+mIndex" v-for="(mData, mIndex) in reportSMonthList" :key="mData[0].score">
					<div class="report-season" :class="sColorArr[mIndex]"></div>
					<div class="report-month-data-2" :class="'d-'+mmIndex" v-for="(mmData, mmIndex) in mData" :key="mmData.time">
						<div class="report-sub-title"><span class="text" :class="'t-'+colorArr[mIndex]">{{mmData.m+'月'}}</span></div>
						<div class="report-month-text" v-for="dText in mmData.des" :key="dText.slice(0, 3)">{{dText}}</div>
					</div>
					<div class="report-gold" :class="'gold-'+mIndex"></div>
				</div>
			</div>
			<!-- 重点提醒 -->
			<div class="report-title-word"><span class="text">重点提醒</span></div>
			<div v-if="reportSPayData && reportSPayData.needpay == 1" class="report-main-content text-c">
				<div class="text-blur text1"></div>
				<div class="report-lock" @click="clickPay"></div>
				<div class="report-cloud cloud1"></div>
			</div>
			<div v-if="reportSPayData && reportSPayData.needpay == 0" class="report-main-content">
				<div class="text" v-for="dText in userPageData.s.pay.info.des" :key="dText.slice(0, 3)">{{dText}}</div>
				<div class="report-cloud cloud1"></div>
			</div>
		</div>
		<div class="report-bottom"></div>
	</div>
</template>

<script>
	import PayButton from '../../components/common/PayButton.vue'
	import ReportDataArea from '../../components/report/ReportDataArea.vue'
	export default {
		components: { PayButton, ReportDataArea },
		computed: {
			userPageData() {
				return this.$store.state.user.userPageData;
			},
			reportSData() {
				return this.$store.state.user.reportSData;
			},
			reportSPayData() {
				return this.$store.state.user.reportSPayData;
			},
			reportSMonthList() {
				return this.$store.state.user.reportSMonthList;
			},
			reportSMCategories() {
				return this.$store.state.user.reportSMCategories;
			},
			reportSMSeries() {
				return this.$store.state.user.reportSMSeries;
			},
		},
		data() {
			return {
				colorArr: ['green', 'red', 'gold', 'blue'],
				sColorArr: ['spring', 'summer', 'autumn', 'winter'],
			}
		},
		methods: {
			clickPay(params) {
				var me = this, 
					curData = params.bData ? params.bData : this.reportSPayData, 
					bPid = params.bPid ? params.bPid : this.userPageData.id;
				if(curData.freeUser && curData.freeUser == 1) {
					this.$store.dispatch('user/freeLockMyReport', {
						params: {
							id: bPid,
							pid: curData.pid
						},
						sucCb: function() {
							// me.$toast('解锁成功');
							me.$store.dispatch('user/getUserHomePageData', { id: bPid });
							// me.$store.state.user.reportShowSuccess = true;
							// setTimeout(() => {
							// 	me.$store.state.user.reportShowSuccess = false;
							// }, 5000);
						},
						failCb: function() {
							me.$toast('解锁失败,请稍后再试~');
						}
					})
				}else {
					this.$store.dispatch('pay/createPayOrder', {
						params: {
							pid: curData.pid,
							ptype: 'wx_qr',  //微信扫码支付
							ext: bPid
						},
						sucCb: function() {
							// me.$toast('支付成功');
							me.$store.dispatch('user/getUserHomePageData', { id: bPid });
							if(params.bCb && typeof(params.bCb) == 'function') {
								params.bCb();
							}
							// me.$store.state.user.reportShowSuccess = true;
							// setTimeout(() => {
							// 	me.$store.state.user.reportShowSuccess = false;
							// }, 5000);
						},
						failCb: function() {
							me.$toast('支付失败,请稍后再试~');
							if(params.bCb && typeof(params.bCb) == 'function') {
								params.bCb();
							}
						}
					})
				}
			}
		}
	}
</script>

<style>
</style>
